import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/The-last-Gemini-/The-last-Gemini-/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/The-last-Gemini-/The-last-Gemini-/src/components/ServiceWorkerRegistration.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/The-last-Gemini-/The-last-Gemini-/src/styles/tailwind.css");
